import { useLocation } from 'react-router-dom';

/**
 * 링크 URL 입력 아래 안내: 페이지 링크는 자동으로 앱으로 열리고, 페이지 밖에 직접 공유할 때는 단축 URL 을 쓰라는 문구.
 * 작성 중인 모듈 입력이 사라지지 않게 단축 URL 탭은 새 창으로 연다.
 */
export function WegetShortLinkHint() {
    const location = useLocation();

    return (
        <p className="mt-2 px-1 text-xs leading-relaxed text-gray-500">
            네이버·유튜브 링크는 인스타·카톡에서 누르면 자동으로 앱으로 열립니다 (고급 옵션에서 끌 수 있음). 페이지 밖에 링크를 직접 공유할 때는 단축 URL 을 쓰세요.{' '}
            <a
                href={`${location.pathname}?tabType=SHORT_LINK`}
                target="_blank"
                rel="noreferrer"
                className="font-semibold text-gray-700 underline whitespace-nowrap"
            >
                단축 URL 만들기 ↗
            </a>
        </p>
    );
}
